import { cn } from "@/lib/cn";
import type { StaticEntityType } from "@config";
import { useIsPdf } from "@library/components";
import type { CSSProperties } from "react";
import { EmbeddedStyled } from "../styles/Embedded.styled";
import type {
  EditorDataProps,
  EditorSlotsProps,
  EmbeddedProps,
} from "../types";
import Code from "./Code";
import Iframe from "./Iframe";
import { Preview } from "./Preview";

export const EmbeddedLibrary = ({
  entity,
  editorSlots,
  editorData,
}: {
  entity: StaticEntityType;
  editorSlots?: EditorSlotsProps;
  editorData?: EditorDataProps;
}) => {
  const { settings } = entity as StaticEntityType<EmbeddedProps>;
  const width = editorData?.width || settings.width;
  const height = editorData?.height || settings.height;
  const isPdf = useIsPdf();

  const isPreview = settings.view === "preview" || isPdf;

  return (
    <EmbeddedStyled
      className="embedded-CNicd88eelKe801 tw-relative tw-flex"
      $horizontalAlignment={settings.horizontalAlignment}
      $round={settings.round}
      style={
        {
          "--entity-size": `${Number(width)}%`,
          "--entity-height": `${isPreview ? "auto" : height + "px"}`,
        } as CSSProperties
      }
      ref={editorData?.containerRef}
    >
      {editorSlots?.resizeSlot}
      {editorSlots?.dynamicVariablePlateSlot}
      {editorSlots?.dynamicVariableDotSlot}
      <div
        className={cn(
          "embedded-CNicd88eelKe801--wrapper tw-overflow-hidden",
          settings.isShadow && "tw-shadow-[rgba(0,_0,_0,_0.15)_0px_4px_8px]",
        )}
        {...EDITOR_ATTRIBUTES({ isEditor: !!editorData })}
      >
        {isPreview ? (
          <Preview entity={entity} />
        ) : (
          <>
            {settings.active === "link" ? (
              <Iframe link={settings.link} isEditor={!!editorSlots} />
            ) : (
              <Code code={settings.code} isEditor={!!editorSlots} />
            )}
            {editorSlots?.placeholderSlot}
          </>
        )}
      </div>
    </EmbeddedStyled>
  );
};

const EDITOR_ATTRIBUTES = ({ isEditor }: { isEditor: boolean }) => {
  const payload: Record<string, string> = {
    "data-dnd-trigger": "true",
  };
  return isEditor ? payload : {};
};
